import {MenuItem, Select, DialogContent, DialogTitle, Grid, IconButton, withStyles} from '@material-ui/core'
import ImportExport from '@material-ui/icons/ImportExport'
import Modal from '@oniti/oniti-modal'
import React, {Component} from 'react'
import ExportsCss from '../Exports/css/ExportsCss'

class Exports extends Component {
  state = {
    open: false,
    type: 'inscriptions',
  };

  /**
   * Ouverture de la modale de choix d'export
   * @return {[type]} [description]
   */
  onClickHandler() {
    this.setState({open: true})
  }

  /**
   * Soumission du choix d'export
   * @return {[type]} [description]
   */
  onSubmitHandler() {
    const {type} = this.state
    let url = process.env.REACT_APP_API_URL + '/exports?type=' + type;

    window.open(url, '_blank')
    this.setState({open: false})
  }

  /**
   * Retourne la modale de choix d'export
   * @return {[type]} [description]
   */
  getModal() {
    const {open, type} = this.state

    if (!open) return null;

    return (
      <Modal
        openModal={open}
        onCloseHandler={() => this.setState({open: false})}
        onSubmitHandler={this.onSubmitHandler.bind(this)}
        fullWidth={true}
        maxWidth='xs'
      >
        <DialogTitle key="title" id="alert-dialog-slide-title">
          <ImportExport/> <span>Exports</span>
        </DialogTitle>
        <DialogContent key="content">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                onChange={event => this.setState({type: event.target.value})}
                fullWidth
              >
                <MenuItem value={'inscriptions'}>Inscriptions</MenuItem>
                <MenuItem value={'decus'}>Déçus</MenuItem>
                <MenuItem value={'tous'}>Tous séjours</MenuItem>
                <MenuItem value={'paiements'}>Paiements</MenuItem>
                <MenuItem value={'stats'}>Statistiques</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
      </Modal>
    );
  }

  render() {
    const {classes} = this.props

    return <>
      <IconButton
        onClick={this.onClickHandler.bind(this)}
        title="Exports"
      >
        <ImportExport className={classes.icon}/>
      </IconButton>
      {this.getModal()}
    </>
  }
}

Exports = withStyles(ExportsCss)(Exports);

export default Exports
